import dayjs from 'dayjs'

export default function renderDatetime(datetime: string) {
    return dayjs(datetime).format('DD.MM.YYYY HH:mm')
}
